import { render, staticRenderFns } from "./TaskTemplateDetailNewForm.vue?vue&type=template&id=edf595ae"
import script from "./TaskTemplateDetailNewForm.vue?vue&type=script&lang=js"
export * from "./TaskTemplateDetailNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports